import { Star, Scissors, MapPin, CalendarCheck } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const ICONS = [Star, Scissors, MapPin, CalendarCheck];

export const USPs = () => {
  const { t } = useLanguage();
  const items = t("usps.items");

  return (
    <section data-testid="usps-section" className="py-20 sm:py-28 px-4 sm:px-6 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-white mb-12 tracking-tight">{t("usps.title")}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {Array.isArray(items) && items.map((item, idx) => {
            const Icon = ICONS[idx % ICONS.length];
            return (
              <div key={item.title} data-testid={`usp-card-${idx}`} className="bg-[#141414] border border-white/5 rounded-xl p-8 hover:border-gold/40 transition-colors">
                <Icon size={28} className="text-gold mb-5" />
                <h3 className="text-white text-lg font-medium mb-2">{item.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{item.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
